module.exports = __webpack_public_path__ + "img/class-bg.5f71341c.png";